<template>
  <section class="root">
    <BrandsGrid :blok="blok"/>
  </section>
</template>

<script>
import cms, { loads } from "@/mixins/cms.js";
export default {
  mixins: [cms, loads],
  name: "cms-brand-list",
  methods: {
    generateLink(name) {
      const brand = name.toLowerCase().replace(/\s/g, "-");
      return `/${this.$language.current}/brands/${brand}`
    }
  },
  computed: {
    filtered() {
      if (!this.blok.filter || this.blok.filter.length == 0) {
        return this.list;
      }
      return this.list.filter(b => this.blok.filter.includes(b.name));
    }
  },
  async fetch() {
    const { data: { results: brands } } = await this.$api.get("public_api/vehicles/makes/");
    this.list = brands;
    this.busy = false;
  },
}
</script>

<style scoped>
div.grid-flow {
  --flow-width: 150px;
}

a.brand {
  display: grid;
  grid-template-rows: fit-content 1fr 1fr;
  align-self: stretch;
  overflow: hidden;
  text-decoration: none;
  color: var(--crf-text);
  padding: 0.8rem;
  border-radius: 8px;
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
}

a.brand img {
  font-style: italic;
  font-size: 0.75rem;
  display: block;
  padding: 20px;
  inline-size: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
}

html:not(.dark) .cms-page img {
  filter: invert(1);
}

p {
  text-align: center;
  margin: 0;
  padding: 0;
}

p.count {
  font-size: 0.8rem;
}
</style>
